import { useMemo } from 'react'
import { GalleryItem } from 'lightgallery/lg-utils'

import { ApiEndpoints } from 'meta/api'

import { GalleryProps } from 'client/components/Gallery/props'

export const useGalleryItems = (props: GalleryProps): Array<GalleryItem> => {
  const { photoPoints } = props

  return useMemo<Array<GalleryItem>>(() => {
    return photoPoints.map<GalleryItem>((photo) => {
      const { photoLabel, photoUuid } = photo.properties

      const src = ApiEndpoints.Photos.photoData(photoUuid)
      return { alt: photoLabel, src, subHtml: `<div>${photoLabel}</div>`, thumb: src }
    })
  }, [photoPoints])
}
